// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_du-3";
export var flatBottomCorners = "_du-5";
export var productImage = "_du-0";
export var quantityContainer = "_du-2";
export var quantityHeader = "_du-6";
export var tooltip = "_du-1";
export var wrapAndEllipsesOverflow = "_du-4";